"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CraftStatus = void 0;
var CraftStatus;
(function (CraftStatus) {
    CraftStatus["ACTIVE"] = "ACTIVE";
    CraftStatus["INACTIVE"] = "INACTIVE";
})(CraftStatus || (exports.CraftStatus = CraftStatus = {}));
//# sourceMappingURL=craft.js.map